import React from 'react';
import './LogisticsTimings.scss';

export const LogisticsTimings = ({ timmings }) => {
  const { estimated, actual, edt_buffer } = timmings;
  return (
    <div className='logisticsTimings tooltip'>
      <React.Fragment>
        <h3 className='tooltipHeading'>Timings:</h3>
        <div className='logisticsTimmingsContent'>
          {edt_buffer ? (
            <div className='bufferdTime'>
              <h3 className='tooltipSubHeading'>Buffer Estimations:</h3>
              {edt_buffer &&
                edt_buffer.map((timing, index) => {
                  if (!timing.value) return null;
                  return (
                    <div className='timingsBox' key={index}>
                      <p className='day'>{timing.name}</p>
                      <p className='bufferValue'>{timing.value}</p>
                    </div>
                  );
                })}
            </div>
          ) : null}
          <div className='estimatedTime'>
            <h3 className='tooltipSubHeading'>Estimations:</h3>
            {estimated &&
              estimated.map((timing, index) => {
                return (
                  <div className='timingsBox' key={index}>
                    <p className='day'>{timing.name}</p>
                    <p>{timing.value}</p>
                  </div>
                );
              })}
          </div>
          <div className='actualTime'>
            <h3 className='tooltipSubHeading'>Actuals:</h3>
            {actual &&
              actual.map((timing, index) => {
                return (
                  <div className='timingsBox' key={index}>
                    <p className='day'>{timing.name}</p>
                    <p>{timing.value}</p>
                  </div>
                );
              })}
          </div>
        </div>
      </React.Fragment>
    </div>
  );
};
